import { render, staticRenderFns } from "./CompanyProviderSkeleton.vue?vue&type=template&id=5c93daa8&"
import script from "./CompanyProviderSkeleton.vue?vue&type=script&lang=js&"
export * from "./CompanyProviderSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports